(function calendarModuleDefinition() {

    'use strict';

    angular.module('Calendar', ['ui.router', 'Config', 'Entities', 'ErrorsExtend', 'dndLists', 'ClickOnce', 'mwl.calendar', 'CalendarControl'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function calendarConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('calendar-view', {
                    url: '/Calendar/View',
                    templateUrl: config.resourceUrl('/views/calendar/calendar.html'),
                    controller: 'CalendarController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CALENDAR READ')
                });
            }
        ]);
})();